<template lang="html">
    <div class="art-buyer col-three">
        <div class="buyer-content">
            <div class="buyer-thumbnail">
                <img :src="'/' + this.buyer.image" alt="Art Buyer">
            </div>
            <div class="col-twelve text-left buyer-toolbar">
                <button class="transparent-button" @click="deleteBuyer">Delete</button>
            </div>
        </div>
    </div>
</template>

<script>
// Component to show art buyer

export default {
  props: ['buyer'],
  methods: {
    deleteBuyer() {
      axios.post('/admin/ajax/delete/buyer', {
        id: this.buyer.id,
        _method: 'delete'
      }).then(() => {
        this.$emit('buyerDeleted', {
          id: this.buyer.id
        });
      });
    }
  }
};
</script>

<style lang="scss">
    .art-buyer {
        max-width: 350px;
        margin-bottom: 25px;
        .buyer-content {
            position: relative;
            background-color: #ffffff;
            border-radius: 3px;
            box-shadow: 0 2px 3px rgba(0, 0, 0, 0.05);
            overflow: hidden;
            .buyer-thumbnail {
                position: relative;
                img {
                    border-radius: 3px 3px 0 0;
                    vertical-align: bottom;
                }
            }
            .buyer-toolbar {
                padding: 15px 10px 3px;
            }
        }
    }
</style>